// 达人端相关路由
import ExpertEndLayout from "@pages/expertEnd/Layout.vue";

export default [
  {
    path: "/expertEnd",
    name: "ExpertEnd",
    component: ExpertEndLayout,
    redirect: "/expertEnd/shareMaterialLibrary",
    meta: {
      requiredAuth: true,
    },
    children: [
      {
        path: "shareMaterialLibrary", // 发圈
        name: "ShareMaterialLibrary",
        meta: {
          navBarFlag: false,
          tabBarFlag: true,
          requiredAuth: true,
          title: "分享素材库"
        },
        component: () => import("@pages/expertEnd/shareMaterialLibrary/shareMaterialLibrary"),
      },
      {
        path: "userBehaviorAnalysis", // 数据中心
        name: "UserBehaviorAnalysis",
        meta: {
          navBarFlag: false,
          tabBarFlag: true,
          requiredAuth: true,
          title: "数据中心"
        },
        component: () => import("@pages/expertEnd/analysis/userBehaviorAnalysis"),
      },
      {
        path: "myProfile", // 我的 (placeholder)
        name: "MyProfile",
        meta: {
          navBarFlag: false,
          tabBarFlag: true,
          requiredAuth: true,
          title: "我的"
        },
        component: () => import("@pages/expertEnd/home"), // 临时使用home作为占位符
      }
    ]
  },
  {
    path: "/expertEndHome", // 旧首页重定向
    redirect: "/expertEnd/userBehaviorAnalysis"
  },
  // 达人端复用运营端的功能页面
  {
    path: "/customerAuditList", // 客户审核 - 复用运营端客户审核
    name: "CustomerAuditList",
    meta: {
      navBarFlag: true,
      tabBarFlag: false,
      requiredAuth: true,
    },
    component: () => import("@pages/operate/customerAudit/cusAuditList"),
  },
  {
    path: "/productAuditList", // 商品审核 - 复用运营端商品审核
    name: "ProductAuditList",
    meta: {
      navBarFlag: true,
      tabBarFlag: false,
      requiredAuth: true,
    },
    component: () => import("@pages/operate/productReview/productList"),
  },
  {
    path: "/salesOrderMaintenance", // 销售订单维护 - 复用运营端订单管理
    name: "SalesOrderMaintenance",
    meta: {
      navBarFlag: true,
      tabBarFlag: false,
      requiredAuth: true,
    },
    component: () => import("@pages/operate/orderAndShipping"),
  },
  {
    path: "/inventoryList", // 库存清单 - 复用供应商端库存清单
    name: "InventoryList",
    meta: {
      navBarFlag: true,
      tabBarFlag: false,
      requiredAuth: true,
    },
    component: () => import("@pages/supplier/inventoryList"),
  },
  {
    path: "/promotionList", // 促销 - 复用运营端促销管理
    name: "PromotionList",
    meta: {
      navBarFlag: true,
      tabBarFlag: false,
      requiredAuth: true,
    },
    component: () => import("@pages/operate/promotion"),
  },
  {
    path: "/publishVideo", // 发布视频 - 复用运营端视频管理
    name: "PublishVideo",
    meta: {
      navBarFlag: true,
      tabBarFlag: false,
      requiredAuth: true,
    },
    component: () => import("@pages/operate/publishVideo/videoList"),
  },

  {
    path: "/expertEnd/myRelease", // 我发布的
    name: "MyRelease",
    meta: {
      navBarFlag: true,
      tabBarFlag: false,
      requiredAuth: true,
    },
    component: () => import("@pages/expertEnd/shareMaterialLibrary/myRelease"),
  },
  {
    path: "/expertEnd/combinationSharingVideoList", // 达人端组合分享视频列表
    name: "ExpertEndCombinationSharingVideoList",
    meta: {
      navBarFlag: false,
      tabBarFlag: false,
      requiredAuth: true,
    },
    component: () => import("@pages/expertEnd/shareMaterialLibrary/expertEndCombinationSharingVideoList"),
  },
  {
    path: "/expertEnd/combinationSharingList", // 达人端组合分享商品列表
    name: "ExpertEndCombinationSharingList",
    meta: {
      navBarFlag: false,
      tabBarFlag: false,
      requiredAuth: true,
    },
    component: () => import("@pages/expertEnd/shareMaterialLibrary/expertEndCombinationSharingList"),
  },
  {
    path: "/expertEnd/combinationSharingVideoAdd", // 达人端组合分享添加视频
    name: "ExpertEndCombinationSharingVideoAdd",
    meta: {
      navBarFlag: false,
      tabBarFlag: false,
      requiredAuth: true,
    },
    component: () => import("@pages/expertEnd/shareMaterialLibrary/expertEndCombinationSharingVideoAdd"),
  },
  {
    path: "/expertEnd/publishVideo", // 发布视频页面
    name: "PublishVideo",
    meta: {
      navBarFlag: false,
      tabBarFlag: false,
      requiredAuth: true,
      title: "发布视频"
    },
    component: () => import("@pages/expertEnd/shareMaterialLibrary/publishVideo"),
  },
  {
    path: "/expertEnd/combinationSharingListAllProduct", // 达人端组合分享添加商品
    name: "ExpertEndCombinationSharingListAllProduct",
    meta: {
      navBarFlag: false,
      tabBarFlag: false,
      requiredAuth: true,
    },
    component: () => import("@pages/expertEnd/shareMaterialLibrary/expertEndCombinationSharingListAllProduct"),
  },
  {
    path: "/expertEnd/publishProduct", // 发布商品页面
    name: "PublishProduct",
    meta: {
      navBarFlag: false,
      tabBarFlag: false,
      requiredAuth: true,
      title: "发布商品"
    },
    component: () => import("@pages/expertEnd/shareMaterialLibrary/publishProduct"),
  },
  {
    path: "/expertEnd/materialVideoShareView", // 达人端视频素材预览页面
    name: "ExpertEndMaterialVideoShareView",
    meta: {
      navBarFlag: false,
      tabBarFlag: false,
      requiredAuth: false, // 分享页面不需要登录验证
    },
    component: () => import("@/pages/expertEnd/shareView/expertEndMaterialVideoShareView.vue"),
  },
  {
    path: "/expertEnd/materialImageShareView", // 达人端图片素材预览页面
    name: "ExpertEndMaterialImageShareView",
    meta: {
      navBarFlag: false,
      tabBarFlag: false,
      requiredAuth: false, // 分享页面不需要登录验证
    },
    component: () => import("@/pages/expertEnd/shareView/expertEndMaterialImageShareView.vue"),
  },
  {
    path: "/cockpit/clientReview", // 日活/回访详情页面
    name: "DailyActiveDetail",
    meta: {
      navBarFlag: false,
      tabBarFlag: false,
      requiredAuth: true,
    },
    component: () => import("@pages/expertEnd/dashboard/dailyActiveDetail"),
  },
  {
    path: "/cockpit/loginLog", // 用户活动详情页面（当日游客、当月月活、当月游客）
    name: "UserActivityDetail",
    meta: {
      navBarFlag: false,
      tabBarFlag: false,
      requiredAuth: true,
    },
    component: () => import("@pages/expertEnd/dashboard/userActivityDetail"),
  },
  {
    path: "/expertEnd/contentDetail/:id", // 内容详情页面
    name: "ContentDetail",
    meta: {
      navBarFlag: false,
      tabBarFlag: false,
      requiredAuth: true,
      title: "内容详情"
    },
    component: () => import("@pages/expertEnd/analysis/contentDetail"),
  },

];